import React, { SyntheticEvent } from 'react';
import styles from './index.scss';
import { IconButton } from '../../../IconButton';
import { IconName } from '@xo-union/dist-iconography';
import { Caption } from '@xo-union/tk-ui-typography';
import Icon from '@xo-union/tk-component-icons';
interface Props {
  iconName: IconName;
  iconLabel?: string;
  ariaLabel?: string;
  onClickHandler?: (e: SyntheticEvent<Element, Event>) => void;
  flipIcon?: boolean;
}

export const PhotoActionButton: React.FC<Props> = ({
  flipIcon,
  iconName,
  iconLabel,
  ariaLabel = '',
  onClickHandler,
}) => {
  return (
    <div className={styles.wrapper}>
      {onClickHandler ? (
        <IconButton
          className={flipIcon ? styles.flip : ''}
          datatestid={`photo-action-button-${iconName}`}
          name={iconName}
          size="md"
          arialabel={ariaLabel}
          onClick={onClickHandler}
        />
      ) : (
        <span className={styles.icon}>
          <Icon size="md" name="share_ios" />
        </span>
      )}
      {iconLabel && <Caption className={styles.label}>{iconLabel}</Caption>}
    </div>
  );
};
